module.exports = __webpack_public_path__ + "img/fconnect3.2b14d29b.png";